import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
  config: PropTypes.object
};

const defaultValue = {};
const {Provider, Consumer} = React.createContext(defaultValue);

const ConfigProvider = (
  {children, config} // eslint-disable-line react/prop-types
) => <Provider value={config}>{children}</Provider>;

ConfigProvider.propTypes = propTypes;

const withConfig = WrappedComponent => {
  class ConsumerHoc extends React.Component {
    render() {
      return (
        <Consumer>
          {value => <WrappedComponent {...this.props} config={value} />}
        </Consumer>
      );
    }
  }

  return ConsumerHoc;
};

export {ConfigProvider as default, withConfig};
